export * from './lib/manage-slack-integration/manage-slack-integration.component';
export * from './lib/ng-slack-integration.module';
